import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attr-shape-15",
  "use": "icon-attr-shape-15-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-attr-shape-15\"><path d=\"M7.385 8h6.168c.632 0 1.239.251 1.686.699l6.457 7.65-6.457 7.649a2.38 2.38 0 0 1-1.686.698H7.385A2.385 2.385 0 0 1 5 22.311V10.385A2.385 2.385 0 0 1 7.385 8m14.01.699A2.38 2.38 0 0 0 19.708 8h-1.86a.5.5 0 0 0-.383.823l5.054 5.987 1.299 1.538-1.299 1.539-5.054 5.987a.5.5 0 0 0 .382.822h1.861c.633 0 1.24-.251 1.687-.698l6.185-7.327a.5.5 0 0 0 0-.645z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol